import React, { useState } from 'react'
import { Button, message } from 'antd'
import { repairWrongPendingBatches } from '../../../../services/api/3dApi'

const ChangeStatusTransferred = (props) => {
    const { batch, refreshBatchInfo } = props

    const _handleClick = async () => {
        const payload = {
            id: batch._id,
            status: "transferred"
        }

        if (batch.status === "pending") {
            const { data } = await repairWrongPendingBatches(payload)
            const { success, error } = data
            if (!success) {
                message.error(error)
            } else {
                refreshBatchInfo()
                message.success("Trạng thái lô đã đổi thành Transferred!!!")
            }
        } else {
            message.error("Chỉ đổi trạng thái Lô: Pending sang Transferred!!!")
        }
    }
    
    return (
        <>
            <Button
                type="primary"
                onClick={_handleClick}
                disabled={batch.status==="pending"? false: true}
                className='mr-3'
                style={{
                    backgroundColor: '#8bc34a',
                    borderColor: '#8bc34a',
                    fontWeight: 600
                }}
            >
                Đã ép
            </Button>
        </>
    )
}

export default ChangeStatusTransferred